<template>
  <div class="bottom-nav">
    <div class="btn-wrap">
      <img src="@/assets/images/nav-btn-1.svg" alt="">
    </div>
    <div class="btn-wrap">
      <img src="@/assets/images/nav-btn-2.svg" alt="">
    </div>
    <div class="btn-wrap list">
      <img src="@/assets/images/nav-btn-3.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.bottom-nav {
  position: fixed;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  max-width: 414px;
  height: 10vh;
  bottom: 0;
  border-radius: 30px 30px 0 0;
  box-shadow: 0 0 10px rgba(#000000, .12);
  .btn-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 6.6vh;
    height: 6.6vh;
    background-color: transparent;
    cursor: pointer;
    &.list {
      background-color: red;
      box-shadow: 2px 3px 3px rgba(#000000, .24);
    }
  }
}
</style>
